import {useEffect} from 'react';
import { styled } from '@mui/material/styles';
import {isKBImageEditor} from "./Chat";


export const getMessageToTheUser = (KB) => {
    let messageToTheUser;
    if (KB?.kbTitle?.startsWith('AI Chat')) {
        messageToTheUser = 'Ask me anything! '
        // messageToTheUser = 'How may I assist? Ask me anything! '
        // messageToTheUser = 'Type your message to the AI '
    } else if (isKBImageEditor(KB)) {
        messageToTheUser = 'What image do you want me to generate? '
    }

    return messageToTheUser
}

export const SuggestionsContainer = styled('div')(({ theme }) => ({
    position: 'absolute',
    bottom: '100%',
    left: 0,
    right: 0,
    margin: 4,
    zIndex: 2,
    maxHeight: '500px',
    overflowY: 'auto',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    '::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '20px',
        backgroundImage: 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(0,0,0,0.5))',
        display: 'none', // Initially hidden
    }
}));

export function createCommand(suggestion) {
    const paramsString = suggestion.params.map(param => `"${param}"`).join(', ');
    const commandString = `/${suggestion.command}(${paramsString})`;
    return commandString
}

export function parseInputLabels(instructions) {
    // Regular expressions to match the InputLabel and InputValue patterns
    const inputLabelRegex = /\$InputLabel\s*=\s*"""([\s\S]+?)"""/g;
    const inputValueRegex = /\$InputValue\s*=\s*"""([\s\S]+?)"""/g;

    // Function to extract matches based on the provided regex
    const extractMatches = (regex) => {
        const matches = [];
        let match;
        while ((match = regex.exec(instructions)) !== null) {
            matches.push(match[1].trim());
        }
        return matches;
    };

    // Extract InputLabels and InputValues
    const inputLabels = extractMatches(inputLabelRegex);
    const inputValues = extractMatches(inputValueRegex);

    // Combine InputLabels and InputValues into an array of objects
    return inputLabels.map((label, index) => ({
        InputLabel: label,
        InputValue: inputValues[index] || ''
    }));
}

export function parseKBCommands(inputText) {
    // Regular expression to match the command pattern with optional parameters
    const commandRegex = /\/(\w+)(?:\(([^)]*)\))?\s+Description:\s+"""([\s\S]+?)"""/g;
    const commands = [];

    let match;
    while ((match = commandRegex.exec(inputText)) !== null) {
        const [, command, paramsString = '', description] = match;
        const params = paramsString ? paramsString.split(',').map(param => param.trim().replace(/^"|"$/g, '')) : [];
        const descriptionLines = description.split('\n').filter(line => line.trim() !== '');

        commands.push({
            command,
            description: descriptionLines[0],
            params
        });
    }

    return commands;
}

export const useOutsideClick = (ref, callback) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]);
};